/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RecordCustomInsight } from '../models/RecordCustomInsight';
import type { RecordDetail } from '../models/RecordDetail';
import type { RecordInsight } from '../models/RecordInsight';
import type { RecordWithRecordPermission } from '../models/RecordWithRecordPermission';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ShareRecordDetailService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get Record
   * @param id
   * @param slug
   * @param query 검색어: 막걸리 보내주세요
   * @returns any Successful Response
   * @throws ApiError
   */
  public getRecordV1WorkspacesSlugRecordsIdSharedGet(
    id: number,
    slug: string,
    query?: string | null
  ): CancelablePromise<RecordWithRecordPermission | RecordDetail> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspaces/{slug}/records/{id}/shared',
      path: {
        id: id,
        slug: slug,
      },
      query: {
        query: query,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Custom Insights
   * 레코드의 커스텀 인사이트를 가져옵니다.
   * @param id
   * @param slug
   * @returns RecordCustomInsight Successful Response
   * @throws ApiError
   */
  public getCustomInsightsV1WorkspacesSlugRecordsIdSharedCustomInsightsGet(
    id: number,
    slug: string
  ): CancelablePromise<Array<RecordCustomInsight>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspaces/{slug}/records/{id}/shared/custom-insights',
      path: {
        id: id,
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Insights
   * 레코드의 인사이트를 가져옵니다.
   * @param id
   * @param slug
   * @returns RecordInsight Successful Response
   * @throws ApiError
   */
  public getInsightsV1WorkspacesSlugRecordsIdSharedInsightsGet(
    id: number,
    slug: string
  ): CancelablePromise<Array<RecordInsight>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspaces/{slug}/records/{id}/shared/insights',
      path: {
        id: id,
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
